module.exports = __webpack_public_path__ + "img/black_bishop.4a97bd76.png";